import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import './_styles.scss';

const EditFleetInfoTooltip = () => (
    <OverlayTrigger
        placement='top'
        overlay={
            <Tooltip>
                <div className='EditFleetInfoTooltip'>
                    <p>
                        Each vehicle can only belong to one fleet at a time. If the vehicle you&apos;re looking for
                        isn&apos;t shown, it&apos;s likely assigned to another fleet.
                    </p>
                    <p>To reassign it:</p>
                    <ol>
                        <li className='EditFleetInfoTooltip__tooltipItem'>1.&nbsp;Finish editing this fleet</li>
                        <li className='EditFleetInfoTooltip__tooltipItem'>
                            2.&nbsp;Remove the vehicle from its current fleet
                        </li>
                        <li className='EditFleetInfoTooltip__tooltipItem'>
                            3.&nbsp;Edit this fleet and add the vehicle
                        </li>
                    </ol>
                </div>
            </Tooltip>
        }
    >
        <span className='rioglyph rioglyph-info-sign EditFleetInfoTooltip__icon' />
    </OverlayTrigger>
);

export default EditFleetInfoTooltip;
